import { classifyRefusal, isApiRefusalError } from "../errors";

export const MAX_RETRIES = 2;
const MAX_RETRY_DELAY_MS = 10_000;

/**
 * Retry only what might pass on its own: network failures and 5xx. A 4xx is the server's answer
 * (a refusal), so asking again changes nothing and can repeat a side effect. A 501 is the same:
 * the route is not served yet, so it will not start working between retries. A maintenance hold is
 * the same: the waiting screen asks again on its own schedule.
 */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRIES) return false;
  if (isApiRefusalError(error)) {
    const { refusal } = error;
    return refusal.status >= 500 && refusal.status !== 501 && classifyRefusal(refusal).kind !== "MAINTENANCE";
  }
  return true;
}

/** 1 s, 2 s, ... capped at 10 s. */
export function retryDelay(failureCount: number): number {
  return Math.min(1000 * 2 ** failureCount, MAX_RETRY_DELAY_MS);
}
